export default __webpack_public_path__ + "static/media/DivineClosed.a96fc9a9.jpeg";